<div
  class="infobox"
  [ngStyle]="{
    'background-image':
      (screenWidth < 1024 || innerWidth < 1024) && item.imgMobile
        ? 'url(' + item.imgMobile + ')'
        : 'url(' + item.img + ')'
  }"
>
  <div class="infobox__body">
    <div class="infobox__body__title" style="--font:{{ font }}">
      <div *ngIf="item.logo" class="infobox__body--container">
        <div
          class="infobox__body--container--logo"
          [ngStyle]="{ 'background-image': 'url(' + item.logo + ')' }"
        ></div>
      </div>
      <h2 [innerHTML]="item.title | translate"></h2>
    </div>

    <div
      *ngIf="item.description"
      class="infobox__body__description"
      style="--font:{{ font }}; --color:{{ color }}"
    >
      <p [innerHTML]="item.description | translate"></p>
    </div>

    <div class="infobox__body__button">
      <a
        *ngIf="isLogged()"
        target="_self"
        class="btn btn--white btn--md"
        [routerLink]="['/' + item.url]"
      >
        {{ item.buttonTitle | translate }}
      </a>
      <a
        *ngIf="!isLogged()"
        target="_self"
        class="btn btn--white btn--md"
        [routerLink]="[]"
        [queryParams]="authPage()"
      >
        {{ item.buttonTitle | translate }}
      </a>
    </div>
  </div>
</div>
